type TAudioTrackList = {
  length: number;
}

interface ExtendedHTMLVideoElement extends HTMLVideoElement {
  mozHasAudio?: boolean;
  webkitAudioDecodedByteCount?: number;
  audioTracks?: TAudioTrackList;
}

export const mediaHasAudio = (videoRef: React.RefObject<HTMLVideoElement | null>): boolean => {
  const video = videoRef.current as ExtendedHTMLVideoElement | null;

  if (!video) {
    return false;
  }

  return (
    video.mozHasAudio ||
    Boolean(video.webkitAudioDecodedByteCount) ||
    Boolean(video.audioTracks && video.audioTracks.length > 0)
  );
};
